import UnauthenticatedLayout from '@/components/layouts/UnauthenticatedLayout';
import { ROUTES } from '@/constants/routes';
import { Route } from 'react-router-dom';
import ActivationExpired from '@/pages/authentication/ActivationExpired';
import ActivationOtp from '@/pages/authentication/ActivationOtp';
import ActivationResend from '@/pages/authentication/ActivationResend';
import ActivationSetPassword from '@/pages/authentication/ActivationSetPassword';
import ForgotPassword from '@/pages/authentication/ForgotPassword';
import ForgotPasswordOtp from '@/pages/authentication/ForgotPasswordOtp';
import ForgotPasswordSuccess from '@/pages/authentication/ForgotPasswordSuccess';
import Otp from '@/pages/authentication/Otp';
import ResetPassword from '@/pages/authentication/ResetPassword';
import Login from '@/pages/authentication/Login';

export const UnauthenticatedRoutes = (
  <Route element={<UnauthenticatedLayout />}>
    <Route path={ROUTES.LOGIN} element={<Login />} />
    <Route path={ROUTES.OTP} element={<Otp />} />
    <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route path={ROUTES.FORGOT_PASSWORD_OTP} element={<ForgotPasswordOtp />} />
    <Route
      path={ROUTES.FORGOT_PASSWORD_SUCCESS}
      element={<ForgotPasswordSuccess />}
    />
    <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
    <Route path={ROUTES.ACTIVATION} element={<ActivationOtp />} />
    <Route
      path={ROUTES.ACTIVATION_SET_PASSWORD}
      element={<ActivationSetPassword />}
    />
    <Route path={ROUTES.ACTIVATION_EXPIRED} element={<ActivationExpired />} />
    <Route path={ROUTES.ACTIVATION_RESEND} element={<ActivationResend />} />
  </Route>
);
